import React, { FC, useCallback } from 'react';
import { ButtonIcon, Icon, Text } from '@cubeyou-team/hx-react-components';

import translations from 'src/lang';
import {
  PANEL_VIEWS,
  useStanleyQueryPanel,
} from '../../../../providers/StanleyQueryPanelContext';

const { STANLEY_QUERY: translation } = translations['en-US'];
const tH = translation.MODAL.HISTORY;

export const StanleyQueryHistoryHeader: FC = () => {
  const {
    setView,
    selectedHistoryRunId,
    setSelectedHistoryRunId,
    stanleyQueryData,
  } = useStanleyQueryPanel();

  const handleBack = useCallback(() => {
    if (selectedHistoryRunId) {
      setSelectedHistoryRunId(null);
      return;
    }

    setView(stanleyQueryData ? PANEL_VIEWS.RESULTS : PANEL_VIEWS.FORM);
  }, [
    selectedHistoryRunId,
    setSelectedHistoryRunId,
    stanleyQueryData,
    setView,
  ]);

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <ButtonIcon
          icon="icon-chevron_left"
          size="large"
          onClick={handleBack}
        />
        <Icon icon="query_temp" size="medium" />
        <Text weight="bold" size="xheadline">
          {tH.TITLE}
        </Text>
      </div>
      <Text weight="semi-bold" size="xbody">
        {tH.REQUEST_INFO}
      </Text>
    </div>
  );
};
